import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ROUTES from "./route/routes.js";
import Login from "./components/login/Login";
import Layout from "./components/layout/Layout.js";
import SimpleView from "./components/simpleView/SimpleView.js";
import NewUserRegistration from "./components/login/NewUserRegistration.js";
import ForgotPassword from "./components/login/ForgotPassword.js";
import ControlPanel from "./components/controlPanel/ControlPanel.js";
import { AuthProvider } from "./context/AuthContext.js";
import ProtectedRoute from "./route/ProtectedRoute.js";
import { NotificationProvider } from "./context/NotificationContext.js";
import Diagnostics from "./components/diagnostics/Diagnostics.js";
import Unauthorized from "./components/unauthorized/Unauthorized.js";
import UserManagement from "./components/userManagement/UserManagement.js";
// import TrainDetails from "./components/simpleView/TrainDetails.js";
import TrainStatusUI from "./components/divisionView/DivisionView.js";
import Reports from "./components/reports/Reports.js";
import MainView from "./components/mainView/MainView.js";
import SiteOverview from "./components/siteOverview/SiteOverview.js";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <NotificationProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Navigate to={ROUTES.LOGIN} />} />
              <Route path={ROUTES.LOGIN} element={<Login />} />
              <Route
                path={ROUTES.NEWUSERREGISTRATION}
                element={<NewUserRegistration />}
              />
              <Route
                path={ROUTES.FORGOTPASSWORD}
                element={<ForgotPassword />}
              />
              <Route
                path={ROUTES.UNAUTHORIZED}
                element={<Unauthorized />}
              />
              <Route path={ROUTES.DASHBOARD} element={<Layout />}>
                <Route
                  index
                  element={<Navigate to={ROUTES.SIMPLEVIEW} replace />}
                />
                <Route
                  path={ROUTES.SIMPLEVIEW}
                  element={
                    <ProtectedRoute
                      element={<SimpleView />}
                      allowedRoles={[
                        "Employee",
                        "Admin",
                        "Demo",
                        "Super Admin",
                      ]}
                    />
                  }
                  // element={<SimpleView />}
                />
                <Route
                  path={ROUTES.DETAILVIEW}
                  element={
                    <ProtectedRoute
                      element={<MainView />}
                      allowedRoles={[
                        "Employee",
                        "Admin",
                        "Demo",
                        "Super Admin",
                      ]}
                    />
                  }
                  // element={<SimpleView />}
                />
                <Route
                  path={ROUTES.CONTROLPANEL}
                  element={
                    <ProtectedRoute
                      element={<ControlPanel />}
                      allowedRoles={["Employee", "Admin", "Super Admin"]}
                    />
                  }
                  // element={<ControlPanel /> }
                />
                <Route
                  path={ROUTES.DIAGNOTIC}
                  element={
                    <ProtectedRoute
                      element={<Diagnostics />}
                      allowedRoles={["Employee", "Admin", "Super Admin"]}
                    />
                  }
                  // element={<Diagnostics /> }
                />
                <Route
                  path={ROUTES.REPORTS}
                  element={
                    <ProtectedRoute
                      element={<Reports />}
                      allowedRoles={["Employee", "Admin", "Super Admin"]}
                    />
                  }
                  // element={<Diagnostics /> }
                />
                <Route
                  path={ROUTES.SITEOVERVIEW}
                  element={
                    <ProtectedRoute
                      element={<SiteOverview />}
                      allowedRoles={["Employee", "Admin", "Super Admin"]}
                    />
                  }
                  // element={<Diagnostics /> }
                />
                
                <Route
                  path={ROUTES.USERMGMT}
                  element={
                    <ProtectedRoute
                      element={<UserManagement />}
                      allowedRoles={["Admin", "Super Admin"]}
                    />
                  }
                  // element={<UserManagement /> }
                />
                <Route
                  path={ROUTES.DIVISIONDETAILS}
                  element={
                    <ProtectedRoute
                      element={<TrainStatusUI/>}
                      allowedRoles={["Admin", "Super Admin"]}
                    />
                  }
                  // element={<TrainStatusUI /> }
                />

              </Route>
            </Routes>
          </Router>
        </NotificationProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
